module.exports = __webpack_public_path__ + "img/login-v2.d9673a22.png";